import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b92da08"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = { class: "flex w-full flex-1 flex-col px-8 py-4" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "flex flex-col items-left pb-4 mb-2 border-b border-gray-500" }
const _hoisted_5 = { class: "flex flex-wrap h-6" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center w-fit mr-4 h-6 py-0.5 px-2 bg-gray-500 rounded"
}
const _hoisted_7 = { class: "flex flex-wrap mb-4" }
const _hoisted_8 = { class: "flex flex-col justify-end" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col justify-between"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 1,
  class: "flex"
}
const _hoisted_12 = {
  key: 0,
  class: "flex flex-1"
}
const _hoisted_13 = { class: "flex p-8" }
const _hoisted_14 = { class: "flex items-center text-center" }
const _hoisted_15 = { class: "flex-col internal-circle" }
const _hoisted_16 = { class: "flex flex-col px-6 w-full" }
const _hoisted_17 = { class: "flex items-center flex-wrap pb-4 border-b border-gray-500" }
const _hoisted_18 = {
  key: 0,
  class: "flex items-center ml-4 h-6 py-0.5 px-2 bg-gray-500 rounded"
}
const _hoisted_19 = { class: "flex mt-4" }
const _hoisted_20 = { class: "flex flex-col flex-2 border-r border-gray-500" }
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = { class: "flex flex-4 justify-center items-center pl-4" }
const _hoisted_23 = { class: "flex items-center justify-center h-18 w-18 rounded-full bg-gray-500" }
const _hoisted_24 = { class: "flex flex-col px-4 flex-3" }
const _hoisted_25 = {
  key: 0,
  class: "flex flex-col justify-between"
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "flex w-full p-8" }
const _hoisted_28 = { class: "flex items-center text-center" }
const _hoisted_29 = { class: "flex-col internal-circle" }
const _hoisted_30 = { class: "flex flex-1 pl-8" }
const _hoisted_31 = { class: "flex flex-col w-full justify-between" }
const _hoisted_32 = { class: "flex flex-wrap h-6" }
const _hoisted_33 = {
  key: 0,
  class: "flex items-center w-fit mr-4 h-6 py-0.5 px-2 bg-gray-500 rounded"
}
const _hoisted_34 = { class: "flex" }
const _hoisted_35 = { class: "flex justify-between" }
const _hoisted_36 = { class: "flex flex-col pr-8" }
const _hoisted_37 = { class: "flex" }
const _hoisted_38 = {
  key: 0,
  class: "flex flex-col justify-end"
}
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 1,
  class: "flex flex-1"
}
const _hoisted_41 = { class: "flex flex-1 p-8" }
const _hoisted_42 = { class: "flex flex-col w-full justify-between" }
const _hoisted_43 = {
  key: 0,
  class: "flex flex-wrap min-h-0"
}
const _hoisted_44 = {
  key: 0,
  class: "flex items-center w-fit mr-4 h-6 py-0.5 px-2 bg-gray-500 rounded"
}
const _hoisted_45 = { class: "flex" }
const _hoisted_46 = { class: "flex justify-between" }
const _hoisted_47 = { class: "flex flex-col pr-4" }
const _hoisted_48 = { class: "flex flex-wrap" }
const _hoisted_49 = { class: "flex flex-col justify-end" }
const _hoisted_50 = {
  key: 2,
  class: "flex flex-1"
}
const _hoisted_51 = { class: "flex w-full py-8 px-4" }
const _hoisted_52 = { class: "flex flex-col w-full xl:px-4 2xl:px-8" }
const _hoisted_53 = { class: "flex flex-col" }
const _hoisted_54 = { class: "flex flex-wrap h-6" }
const _hoisted_55 = {
  key: 0,
  class: "flex items-center w-fit mr-4 h-6 py-0.5 px-2 bg-gray-500 rounded"
}
const _hoisted_56 = { class: "flex h-32" }
const _hoisted_57 = { class: "flex flex-col" }
const _hoisted_58 = { class: "flex flex-col justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ch_typography = _resolveComponent("ch-typography")!
  const _component_ch_icon = _resolveComponent("ch-icon")!
  const _component_ChButton = _resolveComponent("ChButton")!
  const _component_ch_tooltip = _resolveComponent("ch-tooltip")!
  const _component_ch_banner = _resolveComponent("ch-banner")!
  const _component_ch_progress_spinner = _resolveComponent("ch-progress-spinner")!

  return (!_ctx.isDesktop && !_ctx.isMediumDesktop)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ch_banner, { border: "true" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_ch_typography, {
                    variant: "Untitled20Medium",
                    class: "text-white mb-2",
                    asTag: "span"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.course.title), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course.tags, (tag, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (tag !== 'coderV3')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createVNode(_component_ch_typography, {
                                variant: "Untitled12Regular",
                                class: "text-white capitalize",
                                asTag: "span"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t(`home.courses.tags-${tag}`)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ]),
                _createVNode(_component_ch_typography, {
                  variant: "Untitled12Regular",
                  class: "flex items-center text-white mb-2",
                  asTag: "span"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ch_icon, {
                      icon: "fa-flag",
                      iconType: "fa-regular",
                      size: "sm",
                      class: "text-white align-text-bottom mr-1"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.course.camada), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ch_typography, {
                  variant: "Untitled12Regular",
                  class: "flex items-center text-white mb-2",
                  asTag: "span"
                }, {
                  default: _withCtx(() => [
                    (_ctx.course.dates)
                      ? (_openBlock(), _createBlock(_component_ch_icon, {
                          key: 0,
                          icon: "fa-calendar",
                          iconType: "fa-light",
                          size: "sm",
                          class: "text-white align-text-bottom mr-1"
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.course.dates), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.course.days)
                    ? (_openBlock(), _createBlock(_component_ch_typography, {
                        key: 0,
                        variant: "Untitled12Regular",
                        class: "flex items-baseline text-white mr-2",
                        asTag: "span"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ch_icon, {
                            icon: "fa-calendar",
                            iconType: "fa-light",
                            size: "sm",
                            class: "text-white align-text-bottom mr-1"
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.course.days), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.course.hours)
                    ? (_openBlock(), _createBlock(_component_ch_typography, {
                        key: 1,
                        variant: "Untitled12Regular",
                        class: "flex items-baseline text-white",
                        asTag: "span"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ch_icon, {
                            icon: "fa-clock",
                            iconType: "fa-light",
                            size: "sm",
                            class: "text-white align-text-bottom mr-1"
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.course.hours), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.course.accessAvailableFrom)
                    ? (_openBlock(), _createBlock(_component_ch_typography, {
                        key: 2,
                        variant: "Untitled12Regular",
                        class: "flex items-baseline text-white mt-2",
                        asTag: "span"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.course.availableFromMessage), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.course.accessAvailableFrom < _ctx.today)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_ctx.course.percentage != 100)
                          ? (_openBlock(), _createBlock(_component_ChButton, {
                              key: 0,
                              "button-variant": "primary",
                              size: "small",
                              style: _normalizeStyle({ display: _ctx.content.primaryButton.link ? 'block' : 'none' }),
                              label: _ctx.content.primaryButton.label,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.redirect(_ctx.content.primaryButton.label, _ctx.content.primaryButton.link)))
                            }, null, 8, ["style", "label"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ChButton, {
                          class: "w-full mb-2",
                          "button-variant": "link",
                          size: "small",
                          label: _ctx.content.secondaryButton.label,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirect(_ctx.content.secondaryButton.label, _ctx.content.secondaryButton.link, '_blank', true)))
                        }, null, 8, ["label"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_ch_tooltip, {
                          class: "z-10",
                          position: "top"
                        }, {
                          content: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('home.courses.card-disabled')), 1)
                          ]),
                          children: _withCtx(() => [
                            _createVNode(_component_ChButton, {
                              disabled: "",
                              "button-variant": "secondary",
                              size: "small",
                              label: _ctx.content.secondaryButton.label,
                              onClick: ($event: any) => (null)
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        })
                      ])),
                  (_ctx.course.status === 'finished' && _ctx.course.certificateLink)
                    ? (_openBlock(), _createBlock(_component_ChButton, {
                        key: 2,
                        class: "!w-full",
                        "button-variant": "secondary",
                        size: "small",
                        label: _ctx.t('home.courses.download-certificate'),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.redirect('home.courses.download-certificate', _ctx.course.certificateLink)))
                      }, null, 8, ["label"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
        (_ctx.course.status === 'in-progress')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_ctx.isDesktop)
                ? (_openBlock(), _createBlock(_component_ch_banner, {
                    key: 0,
                    border: "true"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_ch_progress_spinner, {
                            size: "110",
                            border: "3",
                            angle: "90",
                            firstGradient: "#EA90FF",
                            secondGradient: "#83AEFB",
                            percent: _ctx.course.percentage
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_ch_typography, {
                                  variant: "Untitled32Medium",
                                  class: "text-white",
                                  asTag: "p"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.course.percentage) + "%", 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ch_typography, {
                                  variant: "Untitled14Regular",
                                  class: "text-white",
                                  asTag: "p"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.course.percentage != 100 ? _ctx.t('home.courses.in-progress') : _ctx.t('home.courses.finalized')), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["percent"])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_ch_typography, {
                              variant: "Untitled20Medium",
                              class: "text-white",
                              asTag: "span"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.course.title), 1)
                              ]),
                              _: 1
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course.tags, (tag, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                (tag !== 'coderV3')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                      _createVNode(_component_ch_typography, {
                                        variant: "Untitled12Regular",
                                        class: "text-white capitalize",
                                        asTag: "span"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.t(`home.courses.tags-${tag}`)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_ch_typography, {
                                variant: "Untitled12Regular",
                                class: "flex items-center text-white mb-2",
                                asTag: "span"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ch_icon, {
                                    icon: "fa-flag",
                                    iconType: "fa-regular",
                                    size: "sm",
                                    class: "text-white align-text-bottom mr-1"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.course.camada), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ch_typography, {
                                variant: "Untitled12Regular",
                                class: "flex items-center text-white mb-2",
                                asTag: "span"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.course.dates)
                                    ? (_openBlock(), _createBlock(_component_ch_icon, {
                                        key: 0,
                                        icon: "fa-calendar",
                                        iconType: "fa-light",
                                        size: "sm",
                                        class: "text-white align-text-bottom mr-1"
                                      }))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(_ctx.course.dates), 1)
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_21, [
                                (_ctx.course.days)
                                  ? (_openBlock(), _createBlock(_component_ch_typography, {
                                      key: 0,
                                      variant: "Untitled12Regular",
                                      class: "flex items-baseline text-white mr-2",
                                      asTag: "span"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ch_icon, {
                                          icon: "fa-calendar",
                                          iconType: "fa-light",
                                          size: "sm",
                                          class: "text-white align-text-bottom mr-1"
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.course.days), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.course.hours)
                                  ? (_openBlock(), _createBlock(_component_ch_typography, {
                                      key: 1,
                                      variant: "Untitled12Regular",
                                      class: "flex items-baseline text-white",
                                      asTag: "span"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ch_icon, {
                                          icon: "fa-clock",
                                          iconType: "fa-light",
                                          size: "sm",
                                          class: "text-white align-text-bottom mr-1"
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.course.hours), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.course.accessAvailableFrom)
                                  ? (_openBlock(), _createBlock(_component_ch_typography, {
                                      key: 2,
                                      variant: "Untitled12Regular",
                                      class: "flex items-baseline text-white",
                                      asTag: "span"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.course.availableFromMessage), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _createVNode(_component_ch_icon, {
                                  icon: _ctx.content.icon,
                                  iconType: "fa-light",
                                  size: "2x",
                                  class: "text-white"
                                }, null, 8, ["icon"])
                              ]),
                              _createElementVNode("div", _hoisted_24, [
                                _createVNode(_component_ch_typography, {
                                  variant: "Untitled16Medium",
                                  class: "text-white mb-2",
                                  asTag: "span"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.content.title), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ch_typography, {
                                  variant: "Untitled14Regular",
                                  class: "text-white mb-2",
                                  asTag: "span"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.content.primaryText), 1)
                                  ]),
                                  _: 1
                                }),
                                (_ctx.content.secondaryText)
                                  ? (_openBlock(), _createBlock(_component_ch_typography, {
                                      key: 0,
                                      variant: "Untitled14Regular",
                                      class: "text-white mb-2",
                                      asTag: "span"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.content.secondaryText), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.course.accessAvailableFrom < _ctx.today)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _createVNode(_component_ChButton, {
                                      class: "mb-4",
                                      "button-variant": "primary",
                                      size: "small",
                                      style: _normalizeStyle({ visibility: _ctx.content.primaryButton.link ? 'visible' : 'hidden' }),
                                      label: _ctx.content.primaryButton.label,
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.redirect(_ctx.content.primaryButton.label, _ctx.content.primaryButton.link)))
                                    }, null, 8, ["style", "label"]),
                                    (_ctx.course.percentage != 100)
                                      ? (_openBlock(), _createBlock(_component_ChButton, {
                                          key: 0,
                                          "button-variant": "secondary",
                                          size: "small",
                                          label: _ctx.content.secondaryButton.label,
                                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.redirect(_ctx.content.secondaryButton.label, _ctx.content.secondaryButton.link, '_blank', true)))
                                        }, null, 8, ["label"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createVNode(_component_ch_tooltip, {
                                      class: "z-10",
                                      position: "top"
                                    }, {
                                      content: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('home.courses.card-disabled')), 1)
                                      ]),
                                      children: _withCtx(() => [
                                        _createVNode(_component_ChButton, {
                                          disabled: "",
                                          "button-variant": "secondary",
                                          size: "small",
                                          label: _ctx.content.secondaryButton.label,
                                          onClick: ($event: any) => (null)
                                        }, null, 8, ["label"])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_ch_banner, { key: 1 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_ch_progress_spinner, {
                            size: "110",
                            border: "3",
                            angle: "90",
                            firstGradient: "#EA90FF",
                            secondGradient: "#83AEFB",
                            percent: _ctx.course.percentage
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_29, [
                                _createVNode(_component_ch_typography, {
                                  variant: "Untitled32Medium",
                                  class: "text-white",
                                  asTag: "p"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.course.percentage) + "%", 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ch_typography, {
                                  variant: "Untitled14Regular",
                                  class: "text-white",
                                  asTag: "p"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.course.percentage != 100 ? _ctx.t('home.courses.in-progress') : _ctx.t('home.courses.finalized')), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["percent"])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course.tags, (tag, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                  (tag !== 'coderV3')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                        _createVNode(_component_ch_typography, {
                                          variant: "Untitled12Regular",
                                          class: "text-white capitalize",
                                          asTag: "span"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t(`home.courses.tags-${tag}`)), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              _createVNode(_component_ch_typography, {
                                variant: "Untitled20Medium",
                                class: "flex text-white my-3",
                                asTag: "span"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.course.title), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _createVNode(_component_ch_typography, {
                                  variant: "Untitled12Regular",
                                  class: "flex items-center text-white mb-2",
                                  asTag: "span"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ch_icon, {
                                      icon: "fa-flag",
                                      iconType: "fa-regular",
                                      size: "sm",
                                      class: "text-white align-text-bottom mr-1"
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.course.camada), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ch_typography, {
                                  variant: "Untitled12Regular",
                                  class: "flex items-center text-white mb-2",
                                  asTag: "span"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.course.dates)
                                      ? (_openBlock(), _createBlock(_component_ch_icon, {
                                          key: 0,
                                          icon: "fa-calendar",
                                          iconType: "fa-light",
                                          size: "sm",
                                          class: "flex items-center text-white align-text-bottom mr-1"
                                        }))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(_ctx.course.dates), 1)
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("div", _hoisted_37, [
                                  (_ctx.course.days)
                                    ? (_openBlock(), _createBlock(_component_ch_typography, {
                                        key: 0,
                                        variant: "Untitled12Regular",
                                        class: "flex items-baseline text-white mr-2",
                                        asTag: "span"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ch_icon, {
                                            icon: "fa-calendar",
                                            iconType: "fa-light",
                                            size: "sm",
                                            class: "text-white align-text-bottom mr-1"
                                          }),
                                          _createTextVNode(" " + _toDisplayString(_ctx.course.days), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.course.hours)
                                    ? (_openBlock(), _createBlock(_component_ch_typography, {
                                        key: 1,
                                        variant: "Untitled12Regular",
                                        class: "flex items-baseline text-white",
                                        asTag: "span"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ch_icon, {
                                            icon: "fa-clock",
                                            iconType: "fa-light",
                                            size: "sm",
                                            class: "text-white align-text-bottom mr-1"
                                          }),
                                          _createTextVNode(" " + _toDisplayString(_ctx.course.hours), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.course.accessAvailableFrom)
                                    ? (_openBlock(), _createBlock(_component_ch_typography, {
                                        key: 2,
                                        variant: "Untitled12Regular",
                                        class: "flex items-baseline text-white",
                                        asTag: "span"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.course.availableFromMessage), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (_ctx.course.accessAvailableFrom < _ctx.today)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    _createVNode(_component_ChButton, {
                                      class: "mb-4",
                                      "button-variant": "primary",
                                      size: "small",
                                      style: _normalizeStyle({ visibility: _ctx.content.primaryButton.link ? 'visible' : 'hidden' }),
                                      label: _ctx.content.primaryButton.label,
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.redirect(_ctx.content.primaryButton.label, _ctx.content.primaryButton.link)))
                                    }, null, 8, ["style", "label"]),
                                    _createVNode(_component_ChButton, {
                                      "button-variant": "secondary",
                                      size: "small",
                                      label: _ctx.content.secondaryButton.label,
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.redirect(_ctx.content.secondaryButton.label, _ctx.content.secondaryButton.link, '_blank', true)))
                                    }, null, 8, ["label"])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                    _createVNode(_component_ch_tooltip, {
                                      class: "z-10",
                                      position: "top"
                                    }, {
                                      content: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('home.courses.card-disabled')), 1)
                                      ]),
                                      children: _withCtx(() => [
                                        _createVNode(_component_ChButton, {
                                          disabled: "",
                                          "button-variant": "secondary",
                                          size: "small",
                                          label: _ctx.content.secondaryButton.label,
                                          onClick: ($event: any) => (null)
                                        }, null, 8, ["label"])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }))
            ]))
          : (_ctx.course.status === 'planned')
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createVNode(_component_ch_banner, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        (_ctx.course.tags.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course.tags, (tag, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                  (tag !== 'coderV3')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                        _createVNode(_component_ch_typography, {
                                          variant: "Untitled12Regular",
                                          class: "text-white capitalize",
                                          asTag: "span"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t(`home.courses.tags-${tag}`)), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_45, [
                          _createVNode(_component_ch_typography, {
                            variant: "Untitled20Medium",
                            class: "flex text-white my-3 custom-title--one-line",
                            asTag: "span"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.course.title), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createVNode(_component_ch_typography, {
                              variant: "Untitled12Regular",
                              class: "flex items-center text-white mb-2",
                              asTag: "span"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ch_icon, {
                                  icon: "fa-flag",
                                  iconType: "fa-regular",
                                  size: "sm",
                                  class: "text-white align-text-bottom mr-1"
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.course.camada), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ch_typography, {
                              variant: "Untitled12Regular",
                              class: "flex items-center text-white mb-2",
                              asTag: "span"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.course.dates)
                                  ? (_openBlock(), _createBlock(_component_ch_icon, {
                                      key: 0,
                                      icon: "fa-calendar",
                                      iconType: "fa-light",
                                      size: "sm",
                                      class: "text-white align-text-bottom mr-1"
                                    }))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(_ctx.course.dates), 1)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_48, [
                              (_ctx.course.days)
                                ? (_openBlock(), _createBlock(_component_ch_typography, {
                                    key: 0,
                                    variant: "Untitled12Regular",
                                    class: "flex items-baseline text-white mr-2",
                                    asTag: "span"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ch_icon, {
                                        icon: "fa-calendar",
                                        iconType: "fa-light",
                                        size: "sm",
                                        class: "text-white align-text-bottom mr-1"
                                      }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.course.days), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.course.hours)
                                ? (_openBlock(), _createBlock(_component_ch_typography, {
                                    key: 1,
                                    variant: "Untitled12Regular",
                                    class: "flex items-baseline text-white",
                                    asTag: "span"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ch_icon, {
                                        icon: "fa-clock",
                                        iconType: "fa-light",
                                        size: "sm",
                                        class: "text-white align-text-bottom mr-1"
                                      }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.course.hours), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.course.accessAvailableFrom)
                                ? (_openBlock(), _createBlock(_component_ch_typography, {
                                    key: 2,
                                    variant: "Untitled12Regular",
                                    class: "flex items-baseline text-white mt-2",
                                    asTag: "span"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.course.availableFromMessage), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _createVNode(_component_ChButton, {
                              "button-variant": "secondary",
                              size: "small",
                              label: _ctx.content.secondaryButton.label,
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.redirect(_ctx.content.secondaryButton.label, _ctx.content.secondaryButton.link, '_blank', true)))
                            }, null, 8, ["label"])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createVNode(_component_ch_banner, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course.tags, (tag, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                (tag !== 'coderV3')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                      _createVNode(_component_ch_typography, {
                                        variant: "Untitled12Regular",
                                        class: "text-white capitalize",
                                        asTag: "span"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.t(`home.courses.tags-${tag}`)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, [
                              _createVNode(_component_ch_typography, {
                                variant: "Untitled20Medium",
                                class: "text-white my-3 custom-title--two-lines",
                                asTag: "span"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.course.title), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ch_typography, {
                                variant: "Untitled12Regular",
                                class: "flex items-center text-white mb-2",
                                asTag: "span"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ch_icon, {
                                    icon: "fa-flag",
                                    iconType: "fa-regular",
                                    size: "sm",
                                    class: "text-white align-text-bottom mr-1"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.course.camada), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createVNode(_component_ChButton, {
                          class: "w-full mb-2",
                          "button-variant": "secondary",
                          size: "small",
                          label: _ctx.content.secondaryButton.label,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.redirect(_ctx.content.secondaryButton.label, _ctx.content.secondaryButton.link, '_blank', true)))
                        }, null, 8, ["label"]),
                        (_ctx.course.certificateLink)
                          ? (_openBlock(), _createBlock(_component_ChButton, {
                              key: 0,
                              class: "!w-full 2xl:!whitespace-nowrap",
                              "button-variant": "link",
                              size: "small",
                              label: _ctx.t('home.courses.download-certificate'),
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.redirect('home.courses.download-certificate', _ctx.course.certificateLink)))
                            }, null, 8, ["label"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]))
      ]))
}